<div class="login-page-wrapper">
    <div class="row g-0 min-vh-100">

        <!-- Colonne gauche : image + overlay tutoriels (desktop uniquement) -->
        <div class="col-md-7 d-none d-md-flex login-bg-col login-image-col"
             [ngStyle]="{'background-image': 'url(assets/images/login/4.jpg)',
                         'background-size': 'cover',
                         'background-position': 'center center'}">

            <!-- Overlay tutoriels desktop -->
            <div *ngIf="playlistActive && videos.length" class="youtube-section">
                <div class="youtube-section-title">
                    <i class="fa fa-play-circle me-1"></i>
                    {{ playlistTitle || 'Tutoriels vidéo' }}
                </div>
                <div class="youtube-section-cards">
                    <div *ngFor="let video of videos"
                         class="video-card tutorial-thumb"
                         (click)="openVideoModal(video, videoModal)"
                         role="button">
                        <div class="thumb-img-wrapper">
                            <img [src]="video.thumbnail" [alt]="video.title" loading="lazy"/>
                            <div class="thumb-play-icon"><i class="fa fa-play"></i></div>
                        </div>
                        <p class="video-title thumb-title">{{ video.title }}</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- Colonne droite : formulaire -->
        <div class="col-12 col-md-5 d-flex flex-column login-form-col">
            <div class="login-card login-dark d-flex align-items-center justify-content-center">
                <div class="w-100">
                    <div class="text-center mb-3">
                        <a class="logo" href="#">
                            <img class="image-logo for-light rounded-circle" src="assets/images/logo/logoanvt1.jpg" alt="Page de connexion">
                            <img class="img-fluid for-dark rounded-circle" src="assets/images/logo/logoanvt1.jpg" alt="Page de connexion">
                        </a>
                    </div>
                    <div class="login-main small-login-card">
                        <form class="theme-form needs-validation" [class.was-validated]="!loginForm.valid" novalidate=""
                              [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                            <h4 class="text-center">Se connecter au compte</h4>
                            <p class="text-center">Entrez votre email et votre mot de passe pour vous connecter</p>

                            <div class="form-group">
                                <label class="col-form-label">Adresse e-mail</label>
                                <input class="form-control" type="email" placeholder="app@yourmail.com" required="" formControlName="email">
                                <div class="invalid-feedback"
                                     *ngIf="loginForm.controls.email.touched && loginForm.controls.email.errors?.required">L'email est requis.</div>
                                <div class="invalid-feedback"
                                     *ngIf="loginForm.controls.email.touched && loginForm.controls.email.errors?.email">Adresse e-mail invalide.</div>
                            </div>

                            <div class="form-group">
                                <label class="col-form-label">Mot de passe</label>
                                <input class="form-control" [type]="show ? 'text' : 'password'" name="login[password]" required=""
                                       placeholder="*********" formControlName="password">
                                <div class="invalid-feedback"
                                     *ngIf="loginForm.controls.password.touched && loginForm.controls.password.errors?.required">Le mot de passe est requis.</div>
                                <div class="show-hide" (click)="showPassword()" *ngIf="!show"><i class="fa fa-eye"></i></div>
                                <div class="show-hide" (click)="showPassword()" *ngIf="show"><i class="fa fa-eye-slash"></i></div>
                            </div>

                            <div class="form-group mb-0">
                                <div class="text-end">
                                    <button type="button" class="btn btn-link" (click)="openModal(passwordResetModal)">
                                        Mot de passe oublié ?
                                    </button>
                                </div>
                                <button class="btn btn-primary d-block w-100" type="submit" [disabled]="!loginForm.valid">Se connecter</button>
                                <ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple"></ngx-spinner>
                            </div>

                            <p class="mt-4 mb-0 text-center">Pas de compte ?
                                <a [routerLink]="'/auth/register'" class="ms-2">Créer un compte</a>
                            </p>
                        </form>
                    </div>
                </div>
            </div>

            <!-- Section tutoriels mobile (sous le formulaire) -->
            <div *ngIf="playlistActive && videos.length" class="youtube-section d-md-none">
                <div class="youtube-section-title">
                    <i class="fa fa-play-circle me-1"></i>
                    {{ playlistTitle || 'Tutoriels vidéo' }}
                </div>
                <div class="youtube-section-cards">
                    <div *ngFor="let video of videos"
                         class="video-card tutorial-thumb"
                         (click)="openVideoModal(video, videoModal)"
                         role="button">
                        <div class="thumb-img-wrapper">
                            <img [src]="video.thumbnail" [alt]="video.title" loading="lazy"/>
                            <div class="thumb-play-icon"><i class="fa fa-play"></i></div>
                        </div>
                        <p class="video-title thumb-title">{{ video.title }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal lecteur vidéo -->
<ng-template #videoModal let-modal>
    <div class="modal-header py-2 border-0 justify-content-between flex-nowrap">
        <h6 class="modal-title text-truncate me-2 flex-shrink-1 min-width-0">{{ selectedVideo?.title }}</h6>
        <div class="d-flex align-items-center gap-1 flex-shrink-0">
            <a *ngIf="selectedVideo"
               [href]="'https://www.youtube.com/watch?v=' + selectedVideo.videoId"
               target="_blank"
               rel="noopener"
               class="btn btn-sm btn-outline-danger">
                <i class="fa fa-youtube-play"></i>
                <span class="d-none d-sm-inline ms-1">Voir sur YouTube</span>
            </a>
            <button type="button" class="btn btn-sm btn-secondary" (click)="modal.dismiss()">Fermer</button>
        </div>
    </div>
    <div class="modal-body p-0">
        <div class="ratio ratio-16x9">
            <iframe *ngIf="selectedVideoUrl"
                    [src]="selectedVideoUrl"
                    allow="autoplay; encrypted-media; fullscreen"
                    allowfullscreen
                    frameborder="0">
            </iframe>
        </div>
    </div>
</ng-template>

<!-- Modal réinitialisation mot de passe -->
<ng-template #passwordResetModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title">Réinitialisation du mot de passe</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <div class="container">
            <div class="row">
                <div class="col-md-8 offset-md-2">
                    <form *ngIf="!resetEmailSent" [formGroup]="resetForm" (ngSubmit)="onResetRequest()">
                        <div class="mb-3 form-group">
                            <label for="email" class="form-label">Adresse email</label>
                            <input type="email"
                                   class="form-control"
                                   id="email"
                                   formControlName="email"
                                   placeholder="Entrez votre email enregistré"
                                   required>
                            <div *ngIf="resetForm.get('email')?.invalid && (resetForm.get('email')?.dirty || resetForm.get('email')?.touched)"
                                 class="text-danger mt-1">
                                <small *ngIf="resetForm.get('email')?.errors?.['required']">Ce champ est requis</small>
                                <small *ngIf="resetForm.get('email')?.errors?.['email']">Veuillez entrer un email valide</small>
                            </div>
                        </div>

                        <div class="d-grid gap-2 mt-4">
                            <button type="submit"
                                    class="btn btn-primary"
                                    [disabled]="!resetForm.valid || isSubmitting">
                                <span *ngIf="!isSubmitting">Envoyer la demande</span>
                                <span *ngIf="isSubmitting">
                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    Envoi en cours...
                                </span>
                            </button>
                        </div>
                    </form>

                    <div *ngIf="resetEmailSent" class="alert alert-success mt-3">
                        <div class="d-flex align-items-center">
                            <i class="fas fa-check-circle me-2"></i>
                            <span>
                                Un email de réinitialisation a été envoyé à <strong>{{ resetForm.get('email')?.value }}</strong>.<br>
                                Veuillez vérifier votre boîte de réception.
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #resendValidationModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title">Refaire la validation de compte</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <div class="container">
            <div class="row">
                <div class="col-md-8 offset-md-2">
                    <form [formGroup]="validationForm" *ngIf="!isCompleted && !hasError">
                        <div class="mb-3">
                            <label for="email" class="form-label">Adresse email</label>
                            <input type="email"
                                   class="form-control"
                                   id="email2"
                                   formControlName="email"
                                   placeholder="Entrez votre email"
                                   required>
                            <div *ngIf="validationForm.get('email')?.invalid &&
                                      (validationForm.get('email')?.dirty || validationForm.get('email')?.touched)"
                                 class="text-danger mt-1 small">
                                <div *ngIf="validationForm.get('email')?.errors?.['required']">L'email est obligatoire</div>
                                <div *ngIf="validationForm.get('email')?.errors?.['email']">Format d'email invalide</div>
                            </div>
                        </div>

                        <div class="d-grid gap-2 mt-4">
                            <button type="button"
                                    class="btn btn-primary"
                                    (click)="resendValidationEmail()"
                                    [disabled]="validationForm.invalid || isProcessing">
                                <span *ngIf="!isProcessing">
                                    <i class="fas fa-paper-plane me-2"></i>Renvoyer l'email
                                </span>
                                <span *ngIf="isProcessing">
                                    <span class="spinner-border spinner-border-sm" role="status"></span>
                                    Envoi en cours...
                                </span>
                            </button>
                        </div>
                    </form>

                    <div *ngIf="isProcessing" class="text-center my-4">
                        <div class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">Chargement...</span>
                        </div>
                        <p class="mt-2 text-muted">Envoi en cours...</p>
                    </div>

                    <div *ngIf="isCompleted" class="alert alert-success mt-3">
                        <div class="d-flex align-items-center">
                            <i class="fas fa-check-circle me-2"></i>
                            <div>
                                <p class="mb-0">Un nouvel email de validation a été envoyé à :</p>
                                <strong>{{ validationForm.get('email')?.value }}</strong>
                            </div>
                        </div>
                        <button class="btn btn-sm btn-success mt-2" (click)="modal.close()">
                            <i class="fas fa-times me-2"></i>Fermer
                        </button>
                    </div>

                    <div *ngIf="hasError" class="alert alert-danger mt-3">
                        <div class="d-flex align-items-center">
                            <i class="fas fa-exclamation-triangle me-2"></i>
                            <span>Erreur lors de l'envoi - Veuillez vérifier l'email et réessayer</span>
                        </div>
                        <button class="btn btn-sm btn-danger mt-2" (click)="hasError = false">
                            <i class="fas fa-redo me-2"></i>Réessayer
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
